module.exports = __webpack_public_path__ + "media/rings.72473ad0.svg";